export var DEFAULT_TIMEOUT = 60000;
export var INTERNAL_ERROR_MARKERS = ['RHUMB_GLOBAL_ERROR', 'RHUMB_GLOBAL_ERROR_BOUNDARY'];